import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";

const API_BASE = "https://api.exampladmedia.com/api/publications";

function SetMarginSlab() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [slabValue, setSlabValue] = useState("");

  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const token = localStorage.getItem("sessionToken");
  const userRole = localStorage.getItem("userRole");
  const isBusinessTeam = userRole === "BUSINESS_TEAM";

  /* ================= FETCH DATA ================= */
  /* ================= FETCH DATA ================= */
const fetchSlabs = async () => {
  setLoading(true);
  try {
    const res = await axios.get(`${API_BASE}/getAllConfigs`, {
      headers: { Authorization: token },
    });

    // 1. Filter records
    const filtered = res.data.filter(
      (item) => item.flag === "SLEBSMARGIN"
    );

    // 2. SORTING LOGIC: Ascending order based on minAmount
    // Isse pura row (value aur date ke saath) minAmount ke hisab se sort ho jayega
    filtered.sort((a, b) => a.minAmount - b.minAmount);

    /* ---------- COLUMNS ---------- */
    const tableColumns = [
      { Header: "Sr. No.", accessor: "srNo", align: "center" },
      { Header: "Cost Price Slab", accessor: "range", align: "center" },
      { Header: "Slab Value", accessor: "slabValue", align: "center" },
      { Header: "Date", accessor: "timestamp", align: "center" },
      ...(!isBusinessTeam
        ? [{ Header: "Actions", accessor: "actions", align: "center" }]
        : []),
    ];

    /* ---------- ROWS ---------- */
    const tableRows = filtered.map((row, index) => ({
      srNo: index + 1, // Ab ye sorted order mein hi 1, 2, 3 dikhayega
      range: `${row.minAmount} - ${row.maxAmount}`,
      slabValue: row.slabValue,
      timestamp: row.timestamp
        ? dayjs(row.timestamp).format("DD-MMM-YYYY")
        : "-",
      ...(!isBusinessTeam && {
        actions: (
          <MDBox display="flex" justifyContent="center" gap={1}>
            <EditIcon
              sx={{ color: "green", cursor: "pointer" }}
              onClick={() => handleEdit(row)}
            />
            <DeleteIcon
              sx={{ color: "red", cursor: "pointer" }}
              onClick={() => handleDeleteConfirm(row)}
            />
          </MDBox>
        ),
      }),
    }));

    setColumns(tableColumns);
    setRows(tableRows);
  } catch (err) {
    console.error(err);
    showSnackbar("Failed to load slab data");
  } finally {
    setLoading(false);
  }
};
  // const fetchSlabs = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await axios.get(`${API_BASE}/getAllConfigs`, {
  //       headers: { Authorization: token },
  //     });

  //     // ✅ ONLY SLEBSMARGIN RECORDS
  //     const filtered = res.data.filter(
  //       (item) => item.flag === "SLEBSMARGIN"
  //     );

  //     /* ---------- COLUMNS ---------- */
  //     const tableColumns = [
  //       { Header: "Sr. No.", accessor: "srNo", align: "center" },
  //       { Header: "Cost Price Slab", accessor: "range", align: "center" },
  //       { Header: "Slab Value", accessor: "slabValue", align: "center" },
  //       { Header: "Date", accessor: "timestamp", align: "center" },

  //       // 👇 Actions only for non-Business_team
  //       ...(!isBusinessTeam
  //         ? [{ Header: "Actions", accessor: "actions", align: "center" }]
  //         : []),
  //     ];

  //     /* ---------- ROWS ---------- */
  //     const tableRows = filtered.map((row, index) => ({
  //       srNo: index + 1,

  //       range: `${row.minAmount} - ${row.maxAmount}`,
  //       // range: `${row.minAmount / 1000}k - ${row.maxAmount / 1000}k`,

  //       slabValue: row.slabValue,

  //       timestamp: row.timestamp
  //         ? dayjs(row.timestamp).format("DD-MMM-YYYY")
  //         : "-",

  //       // 👇 Actions only for non-Business_team
  //       ...(!isBusinessTeam && {
  //         actions: (
  //           <MDBox display="flex" justifyContent="center" gap={1}>
  //             <EditIcon
  //               sx={{ color: "green", cursor: "pointer" }}
  //               onClick={() => handleEdit(row)}
  //             />
  //             <DeleteIcon
  //               sx={{ color: "red", cursor: "pointer" }}
  //               onClick={() => handleDeleteConfirm(row)}
  //             />
  //           </MDBox>
  //         ),
  //       }),
  //     }));

  //     setColumns(tableColumns);
  //     setRows(tableRows);
  //   } catch (err) {
  //     console.error(err);
  //     showSnackbar("Failed to load slab data");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchSlabs();
  }, []);

  /* ================= EDIT ================= */
  const handleEdit = (row) => {
    setSelectedRow(row);
    setSlabValue(row.slabValue);
    setOpenEdit(true);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        minAmount: selectedRow.minAmount,
        maxAmount: selectedRow.maxAmount,
        slabValue: Number(slabValue),
        flag: "SLEBSMARGIN",
      };

      await axios.post(
        `${API_BASE}/updateConfig?id=${selectedRow.id}`,
        payload,
        { headers: { Authorization: token } }
      );

      showSnackbar("Slab value updated successfully");
      setOpenEdit(false);
      fetchSlabs();
    } catch (err) {
      console.error(err);
      showSnackbar("Update failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDeleteConfirm = (row) => {
    setSelectedRow(row);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      await axios.post(
        `${API_BASE}/deleteConfig?id=${selectedRow.id}`,
        null,
        { headers: { Authorization: token } }
      );

      showSnackbar("Slab deleted");
      setOpenDelete(false);
      fetchSlabs();
    } catch (err) {
      console.error(err);
      showSnackbar("Delete failed");
    }
  };

  const showSnackbar = (message) => {
    setSnackbar({ open: true, message });
  };

  /* ================= UI ================= */
  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <h2 style={{ color: "white", margin: 0 }}>
                  Cost Price Slab
                </h2>
              </MDBox>

              <MDBox pt={3}>
                {loading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                  >
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* ================= EDIT DIALOG ================= */}
      {!isBusinessTeam && (
        <Dialog open={openEdit} onClose={() => setOpenEdit(false)}>
          <DialogTitle>Edit Slab Value</DialogTitle>
          <DialogContent>
            <TextField
              label="Slab Value"
              type="number"
              fullWidth
              value={slabValue}
              onChange={(e) => setSlabValue(e.target.value)}
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleUpdate} sx={{ color: "green" }}>
              Save
            </Button>
            <Button onClick={() => setOpenEdit(false)} sx={{ color: "red" }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ================= DELETE DIALOG ================= */}
      {!isBusinessTeam && (
        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this slab?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDelete} sx={{ color: "green" }}>
              Confirm
            </Button>
            <Button onClick={() => setOpenDelete(false)} sx={{ color: "red" }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: "" })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </DashboardLayout>
  );
}

export default SetMarginSlab;
